import { ThemeProvider } from "@mui/material/styles";
import { StylesProvider } from "@mui/styles";
import { themeGenerator } from "@commons/theme";
import { useLocaleContext } from "@contexts/locale";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
// import { prefixer } from "stylis";
// import "normalize.css";

interface ITheme {
  children: React.ReactNode;
}

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [
    // prefixer,
    rtlPlugin,
  ],
});

const ltrCache = createCache({
  key: "mui",
});

const AppTheme = ({ children }: ITheme) => {
  const { direction, muiLocale } = useLocaleContext();
  return (
    <CacheProvider value={direction === "rtl" ? cacheRtl : ltrCache}>
      <StylesProvider>
        <ThemeProvider theme={themeGenerator(muiLocale, direction)}>
          {children}
        </ThemeProvider>
      </StylesProvider>
    </CacheProvider>
  );
};

export { AppTheme };
